import { render, staticRenderFns } from "./ShortcutOverview.vue?vue&type=template&id=5abf97c9&"
import script from "./ShortcutOverview.vue?vue&type=script&lang=js&"
export * from "./ShortcutOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports